import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-ron-mobile-full-screen',
  templateUrl: './ron-mobile-full-screen.component.html',
  styleUrls: ['./ron-mobile-full-screen.component.scss']
})
export class RonMobileFullScreenComponent implements OnInit {

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.loadScript('https://adcdn.nightlife.net/afe755b2.js');
  }

  loadScript(src: string): void {
    const script = this.renderer.createElement('script');
    script.src = src;
    script.async = true;
    this.renderer.appendChild(document.body, script);
  }

}
